const object = value => value && typeof value === 'object' && !Array.isArray(value) ? value : {};
const rows = value => Object.values(object(value)).filter(row => row && typeof row === 'object');
const list = value => Array.isArray(value) ? value.filter(row => row && typeof row === 'object') : rows(value);
const text = value => value == null ? '' : String(value);
const valueOrEmpty = value => value == null ? '' : value;
const percent = value => value != null && value !== '' && Number.isFinite(Number(value)) ? Number(value).toFixed(2) : '';
const series = (data, date, field) => list(data)
  .filter(row => row[date] && row[field] != null && row[field] !== '' && Number.isFinite(Number(row[field])))
  .map(row => [row[date], Number(row[field])]).sort((a, b) => String(a[0]).localeCompare(String(b[0])));

// A complete replacement, never a merge with the previous company's data.
export function fundamentalSnapshot(payload) {
  const data = object(payload), shares = object(data.SharesStats);
  const highlights = object(data.Highlights), valuation = object(data.Valuation);
  const general = object(data.General), financials = object(data.Financials), esg = object(data.ESGScores);
  const balance = object(financials.Balance_Sheet), cash = object(financials.Cash_Flow), income = object(financials.Income_Statement);
  return {
    fundamental_info: {
      SharesOutstanding: shares.SharesOutstanding == null ? '' : shares.SharesOutstanding,
      SharesFloat: shares.SharesFloat == null ? '' : shares.SharesFloat,
      PercentInsiders: percent(shares.PercentInsiders), PercentInstitutions: percent(shares.PercentInstitutions),
      ...Object.fromEntries(['BookValue', 'PEGRatio', 'PERatio'].map(key => [key, highlights[key] == null ? '' : highlights[key]])),
      ...Object.fromEntries(['EnterpriseValue', 'EnterpriseValueEbitda', 'EnterpriseValueRevenue'].map(key => [key, valuation[key] == null ? '' : valuation[key]]))
    },
    url: text(general.WebURL), ESGexist: Object.keys(esg).length > 0,
    ESGScores: { TotalESG: valueOrEmpty(esg.TotalEsg), EnvironmentScore: valueOrEmpty(esg.EnvironmentScore), SocialScore: valueOrEmpty(esg.SocialScore), GovernanceScore: valueOrEmpty(esg.GovernanceScore), ControversyLevel: valueOrEmpty(esg.ControversyLevel) },
    table_body: list(object(data.Holders).Institutions).map(row => ({ Instituciones: text(row.name), 'Acciones actuales': text(row.currentShares) })),
    table_body_officers: list(general.Officers).map(row => ({ Nombre: text(row.Name), Cargo: text(row.Title) })),
    table_body_activities: [],
    balance_currency: text(balance.currency_symbol), cash_flow_currency: text(cash.currency_symbol), income_statement_currency: text(income.currency_symbol),
    balance_data: series(balance.yearly, 'date', 'cash'), cash_flow_data: series(cash.yearly, 'date', 'endPeriodCashFlow'),
    income_statement_data: series(income.yearly, 'date', 'totalRevenue'), earnings_data: series(object(data.Earnings).Annual, 'date', 'epsActual'),
    outstanding_shares_data: series(object(data.outstandingShares).annual, 'dateFormatted', 'shares'),
    employees_data: [], cargando_numero_empleados: false, no_employees_info: true
  };
}

export function hasFundamentalData(data) {
  return ['Highlights', 'SharesStats', 'Valuation', 'Financials', 'General'].some(key => Object.keys(object(object(data)[key])).length > 0);
}

export function fundamentalActivities(data, translate) {
  return list(object(object(data).ESGScores).ActivitiesInvolvement)
    .map(row => ({ Actividad: translate(text(row.Activity)), Involucramiento: text(row.Involvement) }));
}
